import React from 'react';

/**
 * One line of copy where a block has nothing to draw — still loading, empty, or
 * failed. The design has no frame for any of those states, so there is no
 * illustration or call to action here to invent: a sentence in the page lead's
 * own colour. `role` is `status` while waiting and `alert` on a failure.
 */
const Notice = ({ role, children }) => (
    <p role={role} className="tw-m-0 tw-text-start tw-text-[14px] tw-leading-[1.6] tw-text-v2-student-page-lead">
        {children}
    </p>
);

export default Notice;
